import React from 'react';
import PropTypes from 'prop-types';

// Style
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';

// Images
import tickIcon from '/public/siteImages/verifyTick.svg';

import cs from '../../components/commonStyle.css';
import s from './VerifiedInfo.css';

const AccountItem = ({ itemName }) => (
  <div className={s.displayFlex}>
    <h4 className={cx(cs.commonMediumText, cs.fontWeightNormal)}>
      {itemName}
    </h4>
    <img src={tickIcon} className={s.tickIcon} alt="Verified" />
  </div>
);

AccountItem.propTypes = {
  itemName: PropTypes.string.isRequired
};

export default withStyles(cs, s)(AccountItem);
